import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAppConfig } from './config.model';

@Injectable()
export class ConfigService {
    static app: IAppConfig = null;

    constructor(private http: HttpClient) { }
    load() {
        const jsonFile = 'assets/config.json';
        return new Promise<void>((resolve, reject) => {
            this.http.get(jsonFile).toPromise().then((response: IAppConfig) => {
                ConfigService.app = <IAppConfig>response;
                resolve();
            }).catch((response: any) => {
                reject(`Error loading file '${jsonFile}': ${JSON.stringify(response)}`);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/config.service.ts